{
  "formatVersion": 1,
  "name": "blackline-foundry",
  "displayName": "Foundry",
  "description": "A night industrial map: a lit foundry hall at the centre, container yards holding each team's spawn at the short ends, and flank corridors along the long sides breaking up the ground between them. Two bombsites — one by the hall's west furnace, one on the east loading dock — give the round-based mode a home, and the lighting (sodium flank and yard lamps, cool fluorescents under the hall roof, glowing furnace mouths, two floodlit yards) is the map's main character, since night leaves almost no ambient fill.",
  "visual": null,
  "environment": "night",
  "brushes": [
    {
      "kind": "box",
      "center": [
        -28.5,
        -0.25,
        0
      ],
      "halfExtents": [
        11.1,
        0.25,
        28.6
      ],
      "material": "gravel",
      "note": "west yard floor"
    },
    {
      "kind": "box",
      "center": [
        28.5,
        -0.25,
        0
      ],
      "halfExtents": [
        11.1,
        0.25,
        28.6
      ],
      "material": "gravel",
      "note": "east yard floor"
    },
    {
      "kind": "box",
      "center": [
        0,
        -0.25,
        0
      ],
      "halfExtents": [
        17.4,
        0.25,
        9.4
      ],
      "material": "concrete",
      "note": "hall floor"
    },
    {
      "kind": "box",
      "center": [
        0,
        -0.25,
        19
      ],
      "halfExtents": [
        17.4,
        0.25,
        9.6
      ],
      "material": "asphalt",
      "note": "north corridor floor"
    },
    {
      "kind": "box",
      "center": [
        0,
        -0.25,
        -19
      ],
      "halfExtents": [
        17.4,
        0.25,
        9.6
      ],
      "material": "asphalt",
      "note": "south corridor floor"
    },
    {
      "kind": "box",
      "center": [
        -39.3,
        2.25,
        0
      ],
      "halfExtents": [
        0.3,
        2.25,
        28
      ],
      "material": "brick",
      "note": "perimeter west"
    },
    {
      "kind": "box",
      "center": [
        39.3,
        2.25,
        0
      ],
      "halfExtents": [
        0.3,
        2.25,
        28
      ],
      "material": "brick",
      "note": "perimeter east"
    },
    {
      "kind": "box",
      "center": [
        -31.68,
        2.25,
        28.3
      ],
      "halfExtents": [
        7.92,
        2.25,
        0.3
      ],
      "material": "brick",
      "note": "perimeter north seg 0"
    },
    {
      "kind": "box",
      "center": [
        -31.68,
        2.25,
        -28.3
      ],
      "halfExtents": [
        7.92,
        2.25,
        0.3
      ],
      "material": "brick",
      "note": "perimeter south seg 0"
    },
    {
      "kind": "box",
      "center": [
        -15.84,
        2.25,
        28.3
      ],
      "halfExtents": [
        7.92,
        2.25,
        0.3
      ],
      "material": "panel",
      "note": "perimeter north seg 1"
    },
    {
      "kind": "box",
      "center": [
        -15.84,
        2.25,
        -28.3
      ],
      "halfExtents": [
        7.92,
        2.25,
        0.3
      ],
      "material": "panel",
      "note": "perimeter south seg 1"
    },
    {
      "kind": "box",
      "center": [
        0,
        2.25,
        28.3
      ],
      "halfExtents": [
        7.92,
        2.25,
        0.3
      ],
      "material": "brick",
      "note": "perimeter north seg 2"
    },
    {
      "kind": "box",
      "center": [
        0,
        2.25,
        -28.3
      ],
      "halfExtents": [
        7.92,
        2.25,
        0.3
      ],
      "material": "brick",
      "note": "perimeter south seg 2"
    },
    {
      "kind": "box",
      "center": [
        15.84,
        2.25,
        28.3
      ],
      "halfExtents": [
        7.92,
        2.25,
        0.3
      ],
      "material": "panel",
      "note": "perimeter north seg 3"
    },
    {
      "kind": "box",
      "center": [
        15.84,
        2.25,
        -28.3
      ],
      "halfExtents": [
        7.92,
        2.25,
        0.3
      ],
      "material": "panel",
      "note": "perimeter south seg 3"
    },
    {
      "kind": "box",
      "center": [
        31.68,
        2.25,
        28.3
      ],
      "halfExtents": [
        7.92,
        2.25,
        0.3
      ],
      "material": "brick",
      "note": "perimeter north seg 4"
    },
    {
      "kind": "box",
      "center": [
        31.68,
        2.25,
        -28.3
      ],
      "halfExtents": [
        7.92,
        2.25,
        0.3
      ],
      "material": "brick",
      "note": "perimeter south seg 4"
    },
    {
      "kind": "box",
      "center": [
        -16.75,
        3.5,
        -8.8
      ],
      "halfExtents": [
        0.25,
        3.5,
        0.2
      ],
      "material": "brick",
      "note": "hall north wall"
    },
    {
      "kind": "box",
      "center": [
        -15,
        2,
        -8.8
      ],
      "halfExtents": [
        1.5,
        2,
        0.2
      ],
      "material": "brick",
      "note": "hall north sill"
    },
    {
      "kind": "box",
      "center": [
        -15,
        6.25,
        -8.8
      ],
      "halfExtents": [
        1.5,
        0.75,
        0.2
      ],
      "material": "brick",
      "note": "hall north lintel"
    },
    {
      "kind": "box",
      "center": [
        -10.75,
        3.5,
        -8.8
      ],
      "halfExtents": [
        2.75,
        3.5,
        0.2
      ],
      "material": "brick",
      "note": "hall north wall"
    },
    {
      "kind": "box",
      "center": [
        -6.8,
        4.8,
        -8.8
      ],
      "halfExtents": [
        1.2,
        2.2,
        0.2
      ],
      "material": "brick",
      "note": "hall north lintel"
    },
    {
      "kind": "box",
      "center": [
        -5.05,
        3.5,
        -8.8
      ],
      "halfExtents": [
        0.55,
        3.5,
        0.2
      ],
      "material": "brick",
      "note": "hall north wall"
    },
    {
      "kind": "box",
      "center": [
        -3,
        2,
        -8.8
      ],
      "halfExtents": [
        1.5,
        2,
        0.2
      ],
      "material": "brick",
      "note": "hall north sill"
    },
    {
      "kind": "box",
      "center": [
        -3,
        6.25,
        -8.8
      ],
      "halfExtents": [
        1.5,
        0.75,
        0.2
      ],
      "material": "brick",
      "note": "hall north lintel"
    },
    {
      "kind": "box",
      "center": [
        0,
        3.5,
        -8.8
      ],
      "halfExtents": [
        1.5,
        3.5,
        0.2
      ],
      "material": "brick",
      "note": "hall north wall"
    },
    {
      "kind": "box",
      "center": [
        3,
        2,
        -8.8
      ],
      "halfExtents": [
        1.5,
        2,
        0.2
      ],
      "material": "brick",
      "note": "hall north sill"
    },
    {
      "kind": "box",
      "center": [
        3,
        6.25,
        -8.8
      ],
      "halfExtents": [
        1.5,
        0.75,
        0.2
      ],
      "material": "brick",
      "note": "hall north lintel"
    },
    {
      "kind": "box",
      "center": [
        5.05,
        3.5,
        -8.8
      ],
      "halfExtents": [
        0.55,
        3.5,
        0.2
      ],
      "material": "brick",
      "note": "hall north wall"
    },
    {
      "kind": "box",
      "center": [
        6.8,
        4.8,
        -8.8
      ],
      "halfExtents": [
        1.2,
        2.2,
        0.2
      ],
      "material": "brick",
      "note": "hall north lintel"
    },
    {
      "kind": "box",
      "center": [
        10.75,
        3.5,
        -8.8
      ],
      "halfExtents": [
        2.75,
        3.5,
        0.2
      ],
      "material": "brick",
      "note": "hall north wall"
    },
    {
      "kind": "box",
      "center": [
        15,
        2,
        -8.8
      ],
      "halfExtents": [
        1.5,
        2,
        0.2
      ],
      "material": "brick",
      "note": "hall north sill"
    },
    {
      "kind": "box",
      "center": [
        15,
        6.25,
        -8.8
      ],
      "halfExtents": [
        1.5,
        0.75,
        0.2
      ],
      "material": "brick",
      "note": "hall north lintel"
    },
    {
      "kind": "box",
      "center": [
        16.75,
        3.5,
        -8.8
      ],
      "halfExtents": [
        0.25,
        3.5,
        0.2
      ],
      "material": "brick",
      "note": "hall north wall"
    },
    {
      "kind": "box",
      "center": [
        -16.75,
        3.5,
        8.8
      ],
      "halfExtents": [
        0.25,
        3.5,
        0.2
      ],
      "material": "brick",
      "note": "hall south wall"
    },
    {
      "kind": "box",
      "center": [
        -15,
        2,
        8.8
      ],
      "halfExtents": [
        1.5,
        2,
        0.2
      ],
      "material": "brick",
      "note": "hall south sill"
    },
    {
      "kind": "box",
      "center": [
        -15,
        6.25,
        8.8
      ],
      "halfExtents": [
        1.5,
        0.75,
        0.2
      ],
      "material": "brick",
      "note": "hall south lintel"
    },
    {
      "kind": "box",
      "center": [
        -10.75,
        3.5,
        8.8
      ],
      "halfExtents": [
        2.75,
        3.5,
        0.2
      ],
      "material": "brick",
      "note": "hall south wall"
    },
    {
      "kind": "box",
      "center": [
        -6.8,
        4.8,
        8.8
      ],
      "halfExtents": [
        1.2,
        2.2,
        0.2
      ],
      "material": "brick",
      "note": "hall south lintel"
    },
    {
      "kind": "box",
      "center": [
        -5.05,
        3.5,
        8.8
      ],
      "halfExtents": [
        0.55,
        3.5,
        0.2
      ],
      "material": "brick",
      "note": "hall south wall"
    },
    {
      "kind": "box",
      "center": [
        -3,
        2,
        8.8
      ],
      "halfExtents": [
        1.5,
        2,
        0.2
      ],
      "material": "brick",
      "note": "hall south sill"
    },
    {
      "kind": "box",
      "center": [
        -3,
        6.25,
        8.8
      ],
      "halfExtents": [
        1.5,
        0.75,
        0.2
      ],
      "material": "brick",
      "note": "hall south lintel"
    },
    {
      "kind": "box",
      "center": [
        0,
        3.5,
        8.8
      ],
      "halfExtents": [
        1.5,
        3.5,
        0.2
      ],
      "material": "brick",
      "note": "hall south wall"
    },
    {
      "kind": "box",
      "center": [
        3,
        2,
        8.8
      ],
      "halfExtents": [
        1.5,
        2,
        0.2
      ],
      "material": "brick",
      "note": "hall south sill"
    },
    {
      "kind": "box",
      "center": [
        3,
        6.25,
        8.8
      ],
      "halfExtents": [
        1.5,
        0.75,
        0.2
      ],
      "material": "brick",
      "note": "hall south lintel"
    },
    {
      "kind": "box",
      "center": [
        5.05,
        3.5,
        8.8
      ],
      "halfExtents": [
        0.55,
        3.5,
        0.2
      ],
      "material": "brick",
      "note": "hall south wall"
    },
    {
      "kind": "box",
      "center": [
        6.8,
        4.8,
        8.8
      ],
      "halfExtents": [
        1.2,
        2.2,
        0.2
      ],
      "material": "brick",
      "note": "hall south lintel"
    },
    {
      "kind": "box",
      "center": [
        10.75,
        3.5,
        8.8
      ],
      "halfExtents": [
        2.75,
        3.5,
        0.2
      ],
      "material": "brick",
      "note": "hall south wall"
    },
    {
      "kind": "box",
      "center": [
        15,
        2,
        8.8
      ],
      "halfExtents": [
        1.5,
        2,
        0.2
      ],
      "material": "brick",
      "note": "hall south sill"
    },
    {
      "kind": "box",
      "center": [
        15,
        6.25,
        8.8
      ],
      "halfExtents": [
        1.5,
        0.75,
        0.2
      ],
      "material": "brick",
      "note": "hall south lintel"
    },
    {
      "kind": "box",
      "center": [
        16.75,
        3.5,
        8.8
      ],
      "halfExtents": [
        0.25,
        3.5,
        0.2
      ],
      "material": "brick",
      "note": "hall south wall"
    },
    {
      "kind": "box",
      "center": [
        16.8,
        3.5,
        -5.8
      ],
      "halfExtents": [
        0.2,
        3.5,
        2.8
      ],
      "material": "brick",
      "note": "hall east wall"
    },
    {
      "kind": "box",
      "center": [
        16.8,
        5.75,
        0
      ],
      "halfExtents": [
        0.2,
        1.25,
        3
      ],
      "material": "brick",
      "note": "hall east lintel"
    },
    {
      "kind": "box",
      "center": [
        16.8,
        3.5,
        5.8
      ],
      "halfExtents": [
        0.2,
        3.5,
        2.8
      ],
      "material": "brick",
      "note": "hall east wall"
    },
    {
      "kind": "box",
      "center": [
        -16.8,
        3.5,
        -5.8
      ],
      "halfExtents": [
        0.2,
        3.5,
        2.8
      ],
      "material": "brick",
      "note": "hall west wall"
    },
    {
      "kind": "box",
      "center": [
        -16.8,
        5.75,
        0
      ],
      "halfExtents": [
        0.2,
        1.25,
        3
      ],
      "material": "brick",
      "note": "hall west lintel"
    },
    {
      "kind": "box",
      "center": [
        -16.8,
        3.5,
        5.8
      ],
      "halfExtents": [
        0.2,
        3.5,
        2.8
      ],
      "material": "brick",
      "note": "hall west wall"
    },
    {
      "kind": "box",
      "center": [
        0,
        7.2,
        0
      ],
      "halfExtents": [
        17,
        0.2,
        9
      ],
      "material": "panel",
      "note": "hall roof"
    },
    {
      "kind": "box",
      "center": [
        0,
        3.05,
        6.6
      ],
      "halfExtents": [
        16.6,
        0.15,
        2
      ],
      "material": "metal",
      "note": "mezzanine floor"
    },
    {
      "kind": "box",
      "center": [
        -13,
        0.075,
        0.838
      ],
      "halfExtents": [
        1.1,
        0.075,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs west step 1"
    },
    {
      "kind": "box",
      "center": [
        -13,
        0.15,
        1.013
      ],
      "halfExtents": [
        1.1,
        0.15,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs west step 2"
    },
    {
      "kind": "box",
      "center": [
        -13,
        0.225,
        1.188
      ],
      "halfExtents": [
        1.1,
        0.225,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs west step 3"
    },
    {
      "kind": "box",
      "center": [
        -13,
        0.3,
        1.362
      ],
      "halfExtents": [
        1.1,
        0.3,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs west step 4"
    },
    {
      "kind": "box",
      "center": [
        -13,
        0.375,
        1.538
      ],
      "halfExtents": [
        1.1,
        0.375,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs west step 5"
    },
    {
      "kind": "box",
      "center": [
        -13,
        0.45,
        1.713
      ],
      "halfExtents": [
        1.1,
        0.45,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs west step 6"
    },
    {
      "kind": "box",
      "center": [
        -13,
        0.525,
        1.888
      ],
      "halfExtents": [
        1.1,
        0.525,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs west step 7"
    },
    {
      "kind": "box",
      "center": [
        -13,
        0.6,
        2.063
      ],
      "halfExtents": [
        1.1,
        0.6,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs west step 8"
    },
    {
      "kind": "box",
      "center": [
        -13,
        0.675,
        2.238
      ],
      "halfExtents": [
        1.1,
        0.675,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs west step 9"
    },
    {
      "kind": "box",
      "center": [
        -13,
        0.75,
        2.412
      ],
      "halfExtents": [
        1.1,
        0.75,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs west step 10"
    },
    {
      "kind": "box",
      "center": [
        -13,
        0.825,
        2.588
      ],
      "halfExtents": [
        1.1,
        0.825,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs west step 11"
    },
    {
      "kind": "box",
      "center": [
        -13,
        0.9,
        2.762
      ],
      "halfExtents": [
        1.1,
        0.9,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs west step 12"
    },
    {
      "kind": "box",
      "center": [
        -13,
        0.975,
        2.938
      ],
      "halfExtents": [
        1.1,
        0.975,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs west step 13"
    },
    {
      "kind": "box",
      "center": [
        -13,
        1.05,
        3.113
      ],
      "halfExtents": [
        1.1,
        1.05,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs west step 14"
    },
    {
      "kind": "box",
      "center": [
        -13,
        1.125,
        3.287
      ],
      "halfExtents": [
        1.1,
        1.125,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs west step 15"
    },
    {
      "kind": "box",
      "center": [
        -13,
        1.2,
        3.463
      ],
      "halfExtents": [
        1.1,
        1.2,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs west step 16"
    },
    {
      "kind": "box",
      "center": [
        -13,
        1.275,
        3.637
      ],
      "halfExtents": [
        1.1,
        1.275,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs west step 17"
    },
    {
      "kind": "box",
      "center": [
        -13,
        1.35,
        3.813
      ],
      "halfExtents": [
        1.1,
        1.35,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs west step 18"
    },
    {
      "kind": "box",
      "center": [
        -13,
        1.425,
        3.988
      ],
      "halfExtents": [
        1.1,
        1.425,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs west step 19"
    },
    {
      "kind": "box",
      "center": [
        -13,
        1.5,
        4.163
      ],
      "halfExtents": [
        1.1,
        1.5,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs west step 20"
    },
    {
      "kind": "box",
      "center": [
        -13,
        1.575,
        4.338
      ],
      "halfExtents": [
        1.1,
        1.575,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs west step 21"
    },
    {
      "kind": "box",
      "center": [
        -13,
        1.6,
        4.512
      ],
      "halfExtents": [
        1.1,
        1.6,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs west step 22"
    },
    {
      "kind": "box",
      "center": [
        12,
        0.075,
        0.838
      ],
      "halfExtents": [
        1.1,
        0.075,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs east step 1"
    },
    {
      "kind": "box",
      "center": [
        12,
        0.15,
        1.013
      ],
      "halfExtents": [
        1.1,
        0.15,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs east step 2"
    },
    {
      "kind": "box",
      "center": [
        12,
        0.225,
        1.188
      ],
      "halfExtents": [
        1.1,
        0.225,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs east step 3"
    },
    {
      "kind": "box",
      "center": [
        12,
        0.3,
        1.362
      ],
      "halfExtents": [
        1.1,
        0.3,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs east step 4"
    },
    {
      "kind": "box",
      "center": [
        12,
        0.375,
        1.538
      ],
      "halfExtents": [
        1.1,
        0.375,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs east step 5"
    },
    {
      "kind": "box",
      "center": [
        12,
        0.45,
        1.713
      ],
      "halfExtents": [
        1.1,
        0.45,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs east step 6"
    },
    {
      "kind": "box",
      "center": [
        12,
        0.525,
        1.888
      ],
      "halfExtents": [
        1.1,
        0.525,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs east step 7"
    },
    {
      "kind": "box",
      "center": [
        12,
        0.6,
        2.063
      ],
      "halfExtents": [
        1.1,
        0.6,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs east step 8"
    },
    {
      "kind": "box",
      "center": [
        12,
        0.675,
        2.238
      ],
      "halfExtents": [
        1.1,
        0.675,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs east step 9"
    },
    {
      "kind": "box",
      "center": [
        12,
        0.75,
        2.412
      ],
      "halfExtents": [
        1.1,
        0.75,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs east step 10"
    },
    {
      "kind": "box",
      "center": [
        12,
        0.825,
        2.588
      ],
      "halfExtents": [
        1.1,
        0.825,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs east step 11"
    },
    {
      "kind": "box",
      "center": [
        12,
        0.9,
        2.762
      ],
      "halfExtents": [
        1.1,
        0.9,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs east step 12"
    },
    {
      "kind": "box",
      "center": [
        12,
        0.975,
        2.938
      ],
      "halfExtents": [
        1.1,
        0.975,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs east step 13"
    },
    {
      "kind": "box",
      "center": [
        12,
        1.05,
        3.113
      ],
      "halfExtents": [
        1.1,
        1.05,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs east step 14"
    },
    {
      "kind": "box",
      "center": [
        12,
        1.125,
        3.287
      ],
      "halfExtents": [
        1.1,
        1.125,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs east step 15"
    },
    {
      "kind": "box",
      "center": [
        12,
        1.2,
        3.463
      ],
      "halfExtents": [
        1.1,
        1.2,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs east step 16"
    },
    {
      "kind": "box",
      "center": [
        12,
        1.275,
        3.637
      ],
      "halfExtents": [
        1.1,
        1.275,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs east step 17"
    },
    {
      "kind": "box",
      "center": [
        12,
        1.35,
        3.813
      ],
      "halfExtents": [
        1.1,
        1.35,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs east step 18"
    },
    {
      "kind": "box",
      "center": [
        12,
        1.425,
        3.988
      ],
      "halfExtents": [
        1.1,
        1.425,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs east step 19"
    },
    {
      "kind": "box",
      "center": [
        12,
        1.5,
        4.163
      ],
      "halfExtents": [
        1.1,
        1.5,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs east step 20"
    },
    {
      "kind": "box",
      "center": [
        12,
        1.575,
        4.338
      ],
      "halfExtents": [
        1.1,
        1.575,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs east step 21"
    },
    {
      "kind": "box",
      "center": [
        12,
        1.6,
        4.512
      ],
      "halfExtents": [
        1.1,
        1.6,
        0.088
      ],
      "material": "metal",
      "note": "mezzanine stairs east step 22"
    },
    {
      "kind": "box",
      "center": [
        -15.35,
        3.75,
        4.6
      ],
      "halfExtents": [
        1.25,
        0.55,
        0.05
      ],
      "material": "metal",
      "note": "mezz railing"
    },
    {
      "kind": "box",
      "center": [
        -0.5,
        3.75,
        4.6
      ],
      "halfExtents": [
        11.4,
        0.55,
        0.05
      ],
      "material": "metal",
      "note": "mezz railing"
    },
    {
      "kind": "box",
      "center": [
        14.85,
        3.75,
        4.6
      ],
      "halfExtents": [
        1.75,
        0.55,
        0.05
      ],
      "material": "metal",
      "note": "mezz railing"
    },
    {
      "kind": "box",
      "center": [
        -5.8,
        1.75,
        -5
      ],
      "halfExtents": [
        2,
        1.75,
        2
      ],
      "material": "rust",
      "note": "furnace"
    },
    {
      "kind": "box",
      "center": [
        -5.8,
        1,
        -7.025
      ],
      "halfExtents": [
        0.8,
        0.5,
        0.025
      ],
      "material": "rust",
      "emissive": "#ff6a1a",
      "emissiveIntensity": 6,
      "note": "furnace mouth glow"
    },
    {
      "kind": "box",
      "center": [
        0,
        1.75,
        -5
      ],
      "halfExtents": [
        2,
        1.75,
        2
      ],
      "material": "rust",
      "note": "furnace"
    },
    {
      "kind": "box",
      "center": [
        0,
        1,
        -7.025
      ],
      "halfExtents": [
        0.8,
        0.5,
        0.025
      ],
      "material": "rust",
      "emissive": "#ff6a1a",
      "emissiveIntensity": 6,
      "note": "furnace mouth glow"
    },
    {
      "kind": "box",
      "center": [
        5.8,
        1.75,
        -5
      ],
      "halfExtents": [
        2,
        1.75,
        2
      ],
      "material": "rust",
      "note": "furnace"
    },
    {
      "kind": "box",
      "center": [
        5.8,
        1,
        -7.025
      ],
      "halfExtents": [
        0.8,
        0.5,
        0.025
      ],
      "material": "rust",
      "emissive": "#ff6a1a",
      "emissiveIntensity": 6,
      "note": "furnace mouth glow"
    },
    {
      "kind": "box",
      "center": [
        0,
        0,
        -5
      ],
      "halfExtents": [
        9,
        0.01,
        3
      ],
      "material": "paint",
      "note": "furnace safety line"
    },
    {
      "kind": "box",
      "center": [
        -15.5,
        0.6,
        -5
      ],
      "halfExtents": [
        1,
        0.6,
        1.5
      ],
      "material": "concrete",
      "note": "control desk west"
    },
    {
      "kind": "box",
      "center": [
        15.5,
        0.6,
        5
      ],
      "halfExtents": [
        1,
        0.6,
        1.5
      ],
      "material": "concrete",
      "note": "control desk east"
    },
    {
      "kind": "box",
      "center": [
        -16,
        1.1,
        6.5
      ],
      "halfExtents": [
        0.6,
        1.1,
        0.6
      ],
      "material": "concrete",
      "note": "hall pillar"
    },
    {
      "kind": "box",
      "center": [
        16,
        1.1,
        6.5
      ],
      "halfExtents": [
        0.6,
        1.1,
        0.6
      ],
      "material": "concrete",
      "note": "hall pillar"
    },
    {
      "kind": "box",
      "center": [
        -11,
        1.2,
        -7.8
      ],
      "halfExtents": [
        1,
        1.2,
        1
      ],
      "material": "concrete",
      "note": "hall baffle"
    },
    {
      "kind": "box",
      "center": [
        11,
        1.2,
        -7.8
      ],
      "halfExtents": [
        1,
        1.2,
        1
      ],
      "material": "concrete",
      "note": "hall baffle"
    },
    {
      "kind": "box",
      "center": [
        -8,
        1.2,
        6.6
      ],
      "halfExtents": [
        1,
        1.2,
        1
      ],
      "material": "concrete",
      "note": "hall baffle under mezz"
    },
    {
      "kind": "box",
      "center": [
        8,
        1.2,
        6.6
      ],
      "halfExtents": [
        1,
        1.2,
        1
      ],
      "material": "concrete",
      "note": "hall baffle under mezz"
    },
    {
      "kind": "box",
      "center": [
        -15,
        6.5,
        -4
      ],
      "halfExtents": [
        1.4,
        0.06,
        0.15
      ],
      "material": "metal",
      "emissive": "#cfe4ff",
      "emissiveIntensity": 4,
      "note": "hall fluorescent fixture"
    },
    {
      "kind": "box",
      "center": [
        -9,
        6.5,
        -4
      ],
      "halfExtents": [
        1.4,
        0.06,
        0.15
      ],
      "material": "metal",
      "emissive": "#cfe4ff",
      "emissiveIntensity": 4,
      "note": "hall fluorescent fixture"
    },
    {
      "kind": "box",
      "center": [
        -3,
        6.5,
        -4
      ],
      "halfExtents": [
        1.4,
        0.06,
        0.15
      ],
      "material": "metal",
      "emissive": "#cfe4ff",
      "emissiveIntensity": 4,
      "note": "hall fluorescent fixture"
    },
    {
      "kind": "box",
      "center": [
        3,
        6.5,
        -4
      ],
      "halfExtents": [
        1.4,
        0.06,
        0.15
      ],
      "material": "metal",
      "emissive": "#cfe4ff",
      "emissiveIntensity": 4,
      "note": "hall fluorescent fixture"
    },
    {
      "kind": "box",
      "center": [
        9,
        6.5,
        -4
      ],
      "halfExtents": [
        1.4,
        0.06,
        0.15
      ],
      "material": "metal",
      "emissive": "#cfe4ff",
      "emissiveIntensity": 4,
      "note": "hall fluorescent fixture"
    },
    {
      "kind": "box",
      "center": [
        15,
        6.5,
        -4
      ],
      "halfExtents": [
        1.4,
        0.06,
        0.15
      ],
      "material": "metal",
      "emissive": "#cfe4ff",
      "emissiveIntensity": 4,
      "note": "hall fluorescent fixture"
    },
    {
      "kind": "box",
      "center": [
        -15,
        6.5,
        4
      ],
      "halfExtents": [
        1.4,
        0.06,
        0.15
      ],
      "material": "metal",
      "emissive": "#cfe4ff",
      "emissiveIntensity": 4,
      "note": "hall fluorescent fixture"
    },
    {
      "kind": "box",
      "center": [
        -9,
        6.5,
        4
      ],
      "halfExtents": [
        1.4,
        0.06,
        0.15
      ],
      "material": "metal",
      "emissive": "#cfe4ff",
      "emissiveIntensity": 4,
      "note": "hall fluorescent fixture"
    },
    {
      "kind": "box",
      "center": [
        -3,
        6.5,
        4
      ],
      "halfExtents": [
        1.4,
        0.06,
        0.15
      ],
      "material": "metal",
      "emissive": "#cfe4ff",
      "emissiveIntensity": 4,
      "note": "hall fluorescent fixture"
    },
    {
      "kind": "box",
      "center": [
        3,
        6.5,
        4
      ],
      "halfExtents": [
        1.4,
        0.06,
        0.15
      ],
      "material": "metal",
      "emissive": "#cfe4ff",
      "emissiveIntensity": 4,
      "note": "hall fluorescent fixture"
    },
    {
      "kind": "box",
      "center": [
        9,
        6.5,
        4
      ],
      "halfExtents": [
        1.4,
        0.06,
        0.15
      ],
      "material": "metal",
      "emissive": "#cfe4ff",
      "emissiveIntensity": 4,
      "note": "hall fluorescent fixture"
    },
    {
      "kind": "box",
      "center": [
        15,
        6.5,
        4
      ],
      "halfExtents": [
        1.4,
        0.06,
        0.15
      ],
      "material": "metal",
      "emissive": "#cfe4ff",
      "emissiveIntensity": 4,
      "note": "hall fluorescent fixture"
    },
    {
      "kind": "box",
      "center": [
        -24,
        1.3,
        -16
      ],
      "halfExtents": [
        3,
        1.3,
        1.3
      ],
      "material": "rust",
      "note": "container 1"
    },
    {
      "kind": "box",
      "center": [
        -19.7,
        1.3,
        -11.7
      ],
      "halfExtents": [
        1.3,
        1.3,
        3
      ],
      "material": "metal",
      "note": "container 2 (L)"
    },
    {
      "kind": "box",
      "center": [
        -24,
        1.3,
        4
      ],
      "halfExtents": [
        3,
        1.3,
        1.3
      ],
      "material": "rust",
      "note": "container stack lower"
    },
    {
      "kind": "box",
      "center": [
        -24,
        3.9,
        4
      ],
      "halfExtents": [
        3,
        1.3,
        1.3
      ],
      "material": "metal",
      "note": "container stack upper"
    },
    {
      "kind": "box",
      "center": [
        -24,
        1.3,
        -22
      ],
      "halfExtents": [
        3,
        1.3,
        1.3
      ],
      "material": "metal",
      "note": "container 3"
    },
    {
      "kind": "box",
      "center": [
        -24,
        1.3,
        23
      ],
      "halfExtents": [
        3,
        1.3,
        1.3
      ],
      "material": "rust",
      "note": "container 4"
    },
    {
      "kind": "box",
      "center": [
        -25,
        0.6,
        17
      ],
      "halfExtents": [
        2,
        0.6,
        3
      ],
      "material": "concrete",
      "note": "loading dock"
    },
    {
      "kind": "box",
      "center": [
        -21.875,
        0.075,
        17
      ],
      "halfExtents": [
        0.075,
        0.075,
        1.25
      ],
      "material": "concrete",
      "note": "dock stairs step 1"
    },
    {
      "kind": "box",
      "center": [
        -22.025,
        0.15,
        17
      ],
      "halfExtents": [
        0.075,
        0.15,
        1.25
      ],
      "material": "concrete",
      "note": "dock stairs step 2"
    },
    {
      "kind": "box",
      "center": [
        -22.175,
        0.225,
        17
      ],
      "halfExtents": [
        0.075,
        0.225,
        1.25
      ],
      "material": "concrete",
      "note": "dock stairs step 3"
    },
    {
      "kind": "box",
      "center": [
        -22.325,
        0.3,
        17
      ],
      "halfExtents": [
        0.075,
        0.3,
        1.25
      ],
      "material": "concrete",
      "note": "dock stairs step 4"
    },
    {
      "kind": "box",
      "center": [
        -22.475,
        0.375,
        17
      ],
      "halfExtents": [
        0.075,
        0.375,
        1.25
      ],
      "material": "concrete",
      "note": "dock stairs step 5"
    },
    {
      "kind": "box",
      "center": [
        -22.625,
        0.45,
        17
      ],
      "halfExtents": [
        0.075,
        0.45,
        1.25
      ],
      "material": "concrete",
      "note": "dock stairs step 6"
    },
    {
      "kind": "box",
      "center": [
        -22.775,
        0.525,
        17
      ],
      "halfExtents": [
        0.075,
        0.525,
        1.25
      ],
      "material": "concrete",
      "note": "dock stairs step 7"
    },
    {
      "kind": "box",
      "center": [
        -22.925,
        0.6,
        17
      ],
      "halfExtents": [
        0.075,
        0.6,
        1.25
      ],
      "material": "concrete",
      "note": "dock stairs step 8"
    },
    {
      "kind": "box",
      "center": [
        -25,
        1.5,
        -3.85
      ],
      "halfExtents": [
        2,
        1.5,
        0.15
      ],
      "material": "brick",
      "note": "guard hut north wall"
    },
    {
      "kind": "box",
      "center": [
        -25,
        1.5,
        -0.15
      ],
      "halfExtents": [
        2,
        1.5,
        0.15
      ],
      "material": "brick",
      "note": "guard hut south wall"
    },
    {
      "kind": "box",
      "center": [
        -23.15,
        1.5,
        -3.65
      ],
      "halfExtents": [
        0.15,
        1.5,
        0.05
      ],
      "material": "brick",
      "note": "guard hut east wall"
    },
    {
      "kind": "box",
      "center": [
        -23.15,
        0.5,
        -3.2
      ],
      "halfExtents": [
        0.15,
        0.5,
        0.4
      ],
      "material": "brick",
      "note": "guard hut east sill"
    },
    {
      "kind": "box",
      "center": [
        -23.15,
        2.5,
        -3.2
      ],
      "halfExtents": [
        0.15,
        0.5,
        0.4
      ],
      "material": "brick",
      "note": "guard hut east lintel"
    },
    {
      "kind": "box",
      "center": [
        -23.15,
        1.5,
        -2.3
      ],
      "halfExtents": [
        0.15,
        1.5,
        0.5
      ],
      "material": "brick",
      "note": "guard hut east wall"
    },
    {
      "kind": "box",
      "center": [
        -23.15,
        2.6,
        -1.2
      ],
      "halfExtents": [
        0.15,
        0.4,
        0.6
      ],
      "material": "brick",
      "note": "guard hut east lintel"
    },
    {
      "kind": "box",
      "center": [
        -23.15,
        1.5,
        -0.45
      ],
      "halfExtents": [
        0.15,
        1.5,
        0.15
      ],
      "material": "brick",
      "note": "guard hut east wall"
    },
    {
      "kind": "box",
      "center": [
        -26.85,
        1.5,
        -2
      ],
      "halfExtents": [
        0.15,
        1.5,
        1.7
      ],
      "material": "brick",
      "note": "guard hut west wall"
    },
    {
      "kind": "box",
      "center": [
        -25,
        3.1,
        -2
      ],
      "halfExtents": [
        2,
        0.1,
        2
      ],
      "material": "brick",
      "note": "guard hut roof"
    },
    {
      "kind": "box",
      "center": [
        -32,
        1.1,
        -11.7
      ],
      "halfExtents": [
        1.5,
        1.1,
        2
      ],
      "material": "rust",
      "note": "yard lane cover"
    },
    {
      "kind": "box",
      "center": [
        -32,
        1.1,
        6.5
      ],
      "halfExtents": [
        1.5,
        1.1,
        2
      ],
      "material": "rust",
      "note": "yard lane cover"
    },
    {
      "kind": "box",
      "center": [
        -33,
        2.25,
        -25
      ],
      "halfExtents": [
        0.075,
        2.25,
        0.075
      ],
      "material": "metal",
      "note": "yard lamp post"
    },
    {
      "kind": "box",
      "center": [
        -33,
        4.3,
        -25
      ],
      "halfExtents": [
        0.35,
        0.12,
        0.35
      ],
      "material": "metal",
      "emissive": "#ffb35c",
      "emissiveIntensity": 3,
      "note": "yard sodium lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -33,
        2.25,
        -13
      ],
      "halfExtents": [
        0.075,
        2.25,
        0.075
      ],
      "material": "metal",
      "note": "yard lamp post"
    },
    {
      "kind": "box",
      "center": [
        -33,
        4.3,
        -13
      ],
      "halfExtents": [
        0.35,
        0.12,
        0.35
      ],
      "material": "metal",
      "emissive": "#ffb35c",
      "emissiveIntensity": 3,
      "note": "yard sodium lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -33,
        2.25,
        0
      ],
      "halfExtents": [
        0.075,
        2.25,
        0.075
      ],
      "material": "metal",
      "note": "yard lamp post"
    },
    {
      "kind": "box",
      "center": [
        -33,
        4.3,
        0
      ],
      "halfExtents": [
        0.35,
        0.12,
        0.35
      ],
      "material": "metal",
      "emissive": "#ffb35c",
      "emissiveIntensity": 3,
      "note": "yard sodium lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -33,
        2.25,
        13
      ],
      "halfExtents": [
        0.075,
        2.25,
        0.075
      ],
      "material": "metal",
      "note": "yard lamp post"
    },
    {
      "kind": "box",
      "center": [
        -33,
        4.3,
        13
      ],
      "halfExtents": [
        0.35,
        0.12,
        0.35
      ],
      "material": "metal",
      "emissive": "#ffb35c",
      "emissiveIntensity": 3,
      "note": "yard sodium lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -33,
        2.25,
        22
      ],
      "halfExtents": [
        0.075,
        2.25,
        0.075
      ],
      "material": "metal",
      "note": "yard lamp post"
    },
    {
      "kind": "box",
      "center": [
        -33,
        4.3,
        22
      ],
      "halfExtents": [
        0.35,
        0.12,
        0.35
      ],
      "material": "metal",
      "emissive": "#ffb35c",
      "emissiveIntensity": 3,
      "note": "yard sodium lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -15,
        0.6,
        24
      ],
      "halfExtents": [
        1.5,
        0.6,
        0.4
      ],
      "material": "concrete",
      "note": "flank barrier"
    },
    {
      "kind": "box",
      "center": [
        -6,
        0.6,
        24
      ],
      "halfExtents": [
        1.5,
        0.6,
        0.4
      ],
      "material": "concrete",
      "note": "flank barrier"
    },
    {
      "kind": "box",
      "center": [
        12,
        0.6,
        24
      ],
      "halfExtents": [
        1.5,
        0.6,
        0.4
      ],
      "material": "concrete",
      "note": "flank barrier"
    },
    {
      "kind": "box",
      "center": [
        -14,
        1.1,
        13
      ],
      "halfExtents": [
        2,
        1.1,
        1
      ],
      "material": "concrete",
      "note": "corridor cover wall"
    },
    {
      "kind": "box",
      "center": [
        -9,
        1.1,
        20
      ],
      "halfExtents": [
        2,
        1.1,
        1
      ],
      "material": "concrete",
      "note": "corridor cover wall"
    },
    {
      "kind": "box",
      "center": [
        -4,
        1.1,
        13
      ],
      "halfExtents": [
        2,
        1.1,
        1
      ],
      "material": "concrete",
      "note": "corridor cover wall"
    },
    {
      "kind": "box",
      "center": [
        6,
        1.1,
        13
      ],
      "halfExtents": [
        2,
        1.1,
        1
      ],
      "material": "concrete",
      "note": "corridor cover wall"
    },
    {
      "kind": "box",
      "center": [
        11,
        1.1,
        20
      ],
      "halfExtents": [
        2,
        1.1,
        1
      ],
      "material": "concrete",
      "note": "corridor cover wall"
    },
    {
      "kind": "box",
      "center": [
        16,
        1.1,
        13
      ],
      "halfExtents": [
        2,
        1.1,
        1
      ],
      "material": "concrete",
      "note": "corridor cover wall"
    },
    {
      "kind": "box",
      "center": [
        -11,
        1.3,
        17
      ],
      "halfExtents": [
        0.2,
        1.3,
        0.2
      ],
      "material": "metal",
      "note": "pipe rack post"
    },
    {
      "kind": "box",
      "center": [
        -9,
        1.3,
        17
      ],
      "halfExtents": [
        0.2,
        1.3,
        0.2
      ],
      "material": "metal",
      "note": "pipe rack post"
    },
    {
      "kind": "box",
      "center": [
        -10,
        2.6,
        17
      ],
      "halfExtents": [
        1,
        0.2,
        0.2
      ],
      "material": "metal",
      "note": "pipe rack pipe"
    },
    {
      "kind": "box",
      "center": [
        7,
        1.3,
        17
      ],
      "halfExtents": [
        0.2,
        1.3,
        0.2
      ],
      "material": "metal",
      "note": "pipe rack post"
    },
    {
      "kind": "box",
      "center": [
        9,
        1.3,
        17
      ],
      "halfExtents": [
        0.2,
        1.3,
        0.2
      ],
      "material": "metal",
      "note": "pipe rack post"
    },
    {
      "kind": "box",
      "center": [
        8,
        2.6,
        17
      ],
      "halfExtents": [
        1,
        0.2,
        0.2
      ],
      "material": "metal",
      "note": "pipe rack pipe"
    },
    {
      "kind": "box",
      "center": [
        -15,
        1.2,
        10.5
      ],
      "halfExtents": [
        2,
        1.2,
        0.2
      ],
      "material": "panel",
      "note": "corridor front wall"
    },
    {
      "kind": "box",
      "center": [
        -7,
        1.2,
        10.5
      ],
      "halfExtents": [
        4,
        1.2,
        0.2
      ],
      "material": "panel",
      "note": "corridor front wall"
    },
    {
      "kind": "box",
      "center": [
        4,
        1.2,
        10.5
      ],
      "halfExtents": [
        5,
        1.2,
        0.2
      ],
      "material": "panel",
      "note": "corridor front wall"
    },
    {
      "kind": "box",
      "center": [
        14,
        1.2,
        10.5
      ],
      "halfExtents": [
        3,
        1.2,
        0.2
      ],
      "material": "panel",
      "note": "corridor front wall"
    },
    {
      "kind": "box",
      "center": [
        -2.75,
        1.75,
        20.65
      ],
      "halfExtents": [
        1.25,
        1.75,
        0.15
      ],
      "material": "plaster",
      "note": "flank office north wall"
    },
    {
      "kind": "box",
      "center": [
        -0.9,
        2.85,
        20.65
      ],
      "halfExtents": [
        0.6,
        0.65,
        0.15
      ],
      "material": "plaster",
      "note": "flank office north lintel"
    },
    {
      "kind": "box",
      "center": [
        0,
        1.75,
        20.65
      ],
      "halfExtents": [
        0.3,
        1.75,
        0.15
      ],
      "material": "plaster",
      "note": "flank office north wall"
    },
    {
      "kind": "box",
      "center": [
        0.9,
        2.85,
        20.65
      ],
      "halfExtents": [
        0.6,
        0.65,
        0.15
      ],
      "material": "plaster",
      "note": "flank office north lintel"
    },
    {
      "kind": "box",
      "center": [
        2.75,
        1.75,
        20.65
      ],
      "halfExtents": [
        1.25,
        1.75,
        0.15
      ],
      "material": "plaster",
      "note": "flank office north wall"
    },
    {
      "kind": "box",
      "center": [
        0,
        1.75,
        25.35
      ],
      "halfExtents": [
        4,
        1.75,
        0.15
      ],
      "material": "plaster",
      "note": "flank office south wall"
    },
    {
      "kind": "box",
      "center": [
        3.85,
        1.75,
        23
      ],
      "halfExtents": [
        0.15,
        1.75,
        2.2
      ],
      "material": "plaster",
      "note": "flank office east wall"
    },
    {
      "kind": "box",
      "center": [
        -3.85,
        1.75,
        23
      ],
      "halfExtents": [
        0.15,
        1.75,
        2.2
      ],
      "material": "plaster",
      "note": "flank office west wall"
    },
    {
      "kind": "box",
      "center": [
        0,
        3.6,
        23
      ],
      "halfExtents": [
        4,
        0.1,
        2.5
      ],
      "material": "plaster",
      "note": "flank office roof"
    },
    {
      "kind": "box",
      "center": [
        -15,
        2.25,
        11
      ],
      "halfExtents": [
        0.075,
        2.25,
        0.075
      ],
      "material": "metal",
      "note": "corridor lamp post"
    },
    {
      "kind": "box",
      "center": [
        -15,
        4.3,
        11
      ],
      "halfExtents": [
        0.35,
        0.12,
        0.35
      ],
      "material": "metal",
      "emissive": "#ffb35c",
      "emissiveIntensity": 3,
      "note": "corridor sodium lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -6,
        2.25,
        11
      ],
      "halfExtents": [
        0.075,
        2.25,
        0.075
      ],
      "material": "metal",
      "note": "corridor lamp post"
    },
    {
      "kind": "box",
      "center": [
        -6,
        4.3,
        11
      ],
      "halfExtents": [
        0.35,
        0.12,
        0.35
      ],
      "material": "metal",
      "emissive": "#ffb35c",
      "emissiveIntensity": 3,
      "note": "corridor sodium lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        3,
        2.25,
        11
      ],
      "halfExtents": [
        0.075,
        2.25,
        0.075
      ],
      "material": "metal",
      "note": "corridor lamp post"
    },
    {
      "kind": "box",
      "center": [
        3,
        4.3,
        11
      ],
      "halfExtents": [
        0.35,
        0.12,
        0.35
      ],
      "material": "metal",
      "emissive": "#ffb35c",
      "emissiveIntensity": 3,
      "note": "corridor sodium lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        12,
        2.25,
        11
      ],
      "halfExtents": [
        0.075,
        2.25,
        0.075
      ],
      "material": "metal",
      "note": "corridor lamp post"
    },
    {
      "kind": "box",
      "center": [
        12,
        4.3,
        11
      ],
      "halfExtents": [
        0.35,
        0.12,
        0.35
      ],
      "material": "metal",
      "emissive": "#ffb35c",
      "emissiveIntensity": 3,
      "note": "corridor sodium lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        24,
        1.3,
        16
      ],
      "halfExtents": [
        3,
        1.3,
        1.3
      ],
      "material": "rust",
      "note": "container 1"
    },
    {
      "kind": "box",
      "center": [
        19.7,
        1.3,
        11.7
      ],
      "halfExtents": [
        1.3,
        1.3,
        3
      ],
      "material": "metal",
      "note": "container 2 (L)"
    },
    {
      "kind": "box",
      "center": [
        24,
        1.3,
        -4
      ],
      "halfExtents": [
        3,
        1.3,
        1.3
      ],
      "material": "rust",
      "note": "container stack lower"
    },
    {
      "kind": "box",
      "center": [
        24,
        3.9,
        -4
      ],
      "halfExtents": [
        3,
        1.3,
        1.3
      ],
      "material": "metal",
      "note": "container stack upper"
    },
    {
      "kind": "box",
      "center": [
        24,
        1.3,
        22
      ],
      "halfExtents": [
        3,
        1.3,
        1.3
      ],
      "material": "metal",
      "note": "container 3"
    },
    {
      "kind": "box",
      "center": [
        24,
        1.3,
        -23
      ],
      "halfExtents": [
        3,
        1.3,
        1.3
      ],
      "material": "rust",
      "note": "container 4"
    },
    {
      "kind": "box",
      "center": [
        25,
        0.6,
        -17
      ],
      "halfExtents": [
        2,
        0.6,
        3
      ],
      "material": "concrete",
      "note": "loading dock"
    },
    {
      "kind": "box",
      "center": [
        21.875,
        0.075,
        -17
      ],
      "halfExtents": [
        0.075,
        0.075,
        1.25
      ],
      "material": "concrete",
      "note": "dock stairs step 1"
    },
    {
      "kind": "box",
      "center": [
        22.025,
        0.15,
        -17
      ],
      "halfExtents": [
        0.075,
        0.15,
        1.25
      ],
      "material": "concrete",
      "note": "dock stairs step 2"
    },
    {
      "kind": "box",
      "center": [
        22.175,
        0.225,
        -17
      ],
      "halfExtents": [
        0.075,
        0.225,
        1.25
      ],
      "material": "concrete",
      "note": "dock stairs step 3"
    },
    {
      "kind": "box",
      "center": [
        22.325,
        0.3,
        -17
      ],
      "halfExtents": [
        0.075,
        0.3,
        1.25
      ],
      "material": "concrete",
      "note": "dock stairs step 4"
    },
    {
      "kind": "box",
      "center": [
        22.475,
        0.375,
        -17
      ],
      "halfExtents": [
        0.075,
        0.375,
        1.25
      ],
      "material": "concrete",
      "note": "dock stairs step 5"
    },
    {
      "kind": "box",
      "center": [
        22.625,
        0.45,
        -17
      ],
      "halfExtents": [
        0.075,
        0.45,
        1.25
      ],
      "material": "concrete",
      "note": "dock stairs step 6"
    },
    {
      "kind": "box",
      "center": [
        22.775,
        0.525,
        -17
      ],
      "halfExtents": [
        0.075,
        0.525,
        1.25
      ],
      "material": "concrete",
      "note": "dock stairs step 7"
    },
    {
      "kind": "box",
      "center": [
        22.925,
        0.6,
        -17
      ],
      "halfExtents": [
        0.075,
        0.6,
        1.25
      ],
      "material": "concrete",
      "note": "dock stairs step 8"
    },
    {
      "kind": "box",
      "center": [
        25,
        1.5,
        3.85
      ],
      "halfExtents": [
        2,
        1.5,
        0.15
      ],
      "material": "brick",
      "note": "guard hut north wall"
    },
    {
      "kind": "box",
      "center": [
        25,
        1.5,
        0.15
      ],
      "halfExtents": [
        2,
        1.5,
        0.15
      ],
      "material": "brick",
      "note": "guard hut south wall"
    },
    {
      "kind": "box",
      "center": [
        23.15,
        1.5,
        3.65
      ],
      "halfExtents": [
        0.15,
        1.5,
        0.05
      ],
      "material": "brick",
      "note": "guard hut east wall"
    },
    {
      "kind": "box",
      "center": [
        23.15,
        0.5,
        3.2
      ],
      "halfExtents": [
        0.15,
        0.5,
        0.4
      ],
      "material": "brick",
      "note": "guard hut east sill"
    },
    {
      "kind": "box",
      "center": [
        23.15,
        2.5,
        3.2
      ],
      "halfExtents": [
        0.15,
        0.5,
        0.4
      ],
      "material": "brick",
      "note": "guard hut east lintel"
    },
    {
      "kind": "box",
      "center": [
        23.15,
        1.5,
        2.3
      ],
      "halfExtents": [
        0.15,
        1.5,
        0.5
      ],
      "material": "brick",
      "note": "guard hut east wall"
    },
    {
      "kind": "box",
      "center": [
        23.15,
        2.6,
        1.2
      ],
      "halfExtents": [
        0.15,
        0.4,
        0.6
      ],
      "material": "brick",
      "note": "guard hut east lintel"
    },
    {
      "kind": "box",
      "center": [
        23.15,
        1.5,
        0.45
      ],
      "halfExtents": [
        0.15,
        1.5,
        0.15
      ],
      "material": "brick",
      "note": "guard hut east wall"
    },
    {
      "kind": "box",
      "center": [
        26.85,
        1.5,
        2
      ],
      "halfExtents": [
        0.15,
        1.5,
        1.7
      ],
      "material": "brick",
      "note": "guard hut west wall"
    },
    {
      "kind": "box",
      "center": [
        25,
        3.1,
        2
      ],
      "halfExtents": [
        2,
        0.1,
        2
      ],
      "material": "brick",
      "note": "guard hut roof"
    },
    {
      "kind": "box",
      "center": [
        32,
        1.1,
        11.7
      ],
      "halfExtents": [
        1.5,
        1.1,
        2
      ],
      "material": "rust",
      "note": "yard lane cover"
    },
    {
      "kind": "box",
      "center": [
        32,
        1.1,
        -6.5
      ],
      "halfExtents": [
        1.5,
        1.1,
        2
      ],
      "material": "rust",
      "note": "yard lane cover"
    },
    {
      "kind": "box",
      "center": [
        33,
        2.25,
        25
      ],
      "halfExtents": [
        0.075,
        2.25,
        0.075
      ],
      "material": "metal",
      "note": "yard lamp post"
    },
    {
      "kind": "box",
      "center": [
        33,
        4.3,
        25
      ],
      "halfExtents": [
        0.35,
        0.12,
        0.35
      ],
      "material": "metal",
      "emissive": "#ffb35c",
      "emissiveIntensity": 3,
      "note": "yard sodium lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        33,
        2.25,
        13
      ],
      "halfExtents": [
        0.075,
        2.25,
        0.075
      ],
      "material": "metal",
      "note": "yard lamp post"
    },
    {
      "kind": "box",
      "center": [
        33,
        4.3,
        13
      ],
      "halfExtents": [
        0.35,
        0.12,
        0.35
      ],
      "material": "metal",
      "emissive": "#ffb35c",
      "emissiveIntensity": 3,
      "note": "yard sodium lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        33,
        2.25,
        0
      ],
      "halfExtents": [
        0.075,
        2.25,
        0.075
      ],
      "material": "metal",
      "note": "yard lamp post"
    },
    {
      "kind": "box",
      "center": [
        33,
        4.3,
        0
      ],
      "halfExtents": [
        0.35,
        0.12,
        0.35
      ],
      "material": "metal",
      "emissive": "#ffb35c",
      "emissiveIntensity": 3,
      "note": "yard sodium lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        33,
        2.25,
        -13
      ],
      "halfExtents": [
        0.075,
        2.25,
        0.075
      ],
      "material": "metal",
      "note": "yard lamp post"
    },
    {
      "kind": "box",
      "center": [
        33,
        4.3,
        -13
      ],
      "halfExtents": [
        0.35,
        0.12,
        0.35
      ],
      "material": "metal",
      "emissive": "#ffb35c",
      "emissiveIntensity": 3,
      "note": "yard sodium lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        33,
        2.25,
        -22
      ],
      "halfExtents": [
        0.075,
        2.25,
        0.075
      ],
      "material": "metal",
      "note": "yard lamp post"
    },
    {
      "kind": "box",
      "center": [
        33,
        4.3,
        -22
      ],
      "halfExtents": [
        0.35,
        0.12,
        0.35
      ],
      "material": "metal",
      "emissive": "#ffb35c",
      "emissiveIntensity": 3,
      "note": "yard sodium lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        15,
        0.6,
        -24
      ],
      "halfExtents": [
        1.5,
        0.6,
        0.4
      ],
      "material": "concrete",
      "note": "flank barrier"
    },
    {
      "kind": "box",
      "center": [
        6,
        0.6,
        -24
      ],
      "halfExtents": [
        1.5,
        0.6,
        0.4
      ],
      "material": "concrete",
      "note": "flank barrier"
    },
    {
      "kind": "box",
      "center": [
        -12,
        0.6,
        -24
      ],
      "halfExtents": [
        1.5,
        0.6,
        0.4
      ],
      "material": "concrete",
      "note": "flank barrier"
    },
    {
      "kind": "box",
      "center": [
        14,
        1.1,
        -13
      ],
      "halfExtents": [
        2,
        1.1,
        1
      ],
      "material": "concrete",
      "note": "corridor cover wall"
    },
    {
      "kind": "box",
      "center": [
        9,
        1.1,
        -20
      ],
      "halfExtents": [
        2,
        1.1,
        1
      ],
      "material": "concrete",
      "note": "corridor cover wall"
    },
    {
      "kind": "box",
      "center": [
        4,
        1.1,
        -13
      ],
      "halfExtents": [
        2,
        1.1,
        1
      ],
      "material": "concrete",
      "note": "corridor cover wall"
    },
    {
      "kind": "box",
      "center": [
        -6,
        1.1,
        -13
      ],
      "halfExtents": [
        2,
        1.1,
        1
      ],
      "material": "concrete",
      "note": "corridor cover wall"
    },
    {
      "kind": "box",
      "center": [
        -11,
        1.1,
        -20
      ],
      "halfExtents": [
        2,
        1.1,
        1
      ],
      "material": "concrete",
      "note": "corridor cover wall"
    },
    {
      "kind": "box",
      "center": [
        -16,
        1.1,
        -13
      ],
      "halfExtents": [
        2,
        1.1,
        1
      ],
      "material": "concrete",
      "note": "corridor cover wall"
    },
    {
      "kind": "box",
      "center": [
        11,
        1.3,
        -17
      ],
      "halfExtents": [
        0.2,
        1.3,
        0.2
      ],
      "material": "metal",
      "note": "pipe rack post"
    },
    {
      "kind": "box",
      "center": [
        9,
        1.3,
        -17
      ],
      "halfExtents": [
        0.2,
        1.3,
        0.2
      ],
      "material": "metal",
      "note": "pipe rack post"
    },
    {
      "kind": "box",
      "center": [
        10,
        2.6,
        -17
      ],
      "halfExtents": [
        1,
        0.2,
        0.2
      ],
      "material": "metal",
      "note": "pipe rack pipe"
    },
    {
      "kind": "box",
      "center": [
        -7,
        1.3,
        -17
      ],
      "halfExtents": [
        0.2,
        1.3,
        0.2
      ],
      "material": "metal",
      "note": "pipe rack post"
    },
    {
      "kind": "box",
      "center": [
        -9,
        1.3,
        -17
      ],
      "halfExtents": [
        0.2,
        1.3,
        0.2
      ],
      "material": "metal",
      "note": "pipe rack post"
    },
    {
      "kind": "box",
      "center": [
        -8,
        2.6,
        -17
      ],
      "halfExtents": [
        1,
        0.2,
        0.2
      ],
      "material": "metal",
      "note": "pipe rack pipe"
    },
    {
      "kind": "box",
      "center": [
        15,
        1.2,
        -10.5
      ],
      "halfExtents": [
        2,
        1.2,
        0.2
      ],
      "material": "panel",
      "note": "corridor front wall"
    },
    {
      "kind": "box",
      "center": [
        7,
        1.2,
        -10.5
      ],
      "halfExtents": [
        4,
        1.2,
        0.2
      ],
      "material": "panel",
      "note": "corridor front wall"
    },
    {
      "kind": "box",
      "center": [
        -4,
        1.2,
        -10.5
      ],
      "halfExtents": [
        5,
        1.2,
        0.2
      ],
      "material": "panel",
      "note": "corridor front wall"
    },
    {
      "kind": "box",
      "center": [
        -14,
        1.2,
        -10.5
      ],
      "halfExtents": [
        3,
        1.2,
        0.2
      ],
      "material": "panel",
      "note": "corridor front wall"
    },
    {
      "kind": "box",
      "center": [
        2.75,
        1.75,
        -20.65
      ],
      "halfExtents": [
        1.25,
        1.75,
        0.15
      ],
      "material": "plaster",
      "note": "flank office north wall"
    },
    {
      "kind": "box",
      "center": [
        0.9,
        2.85,
        -20.65
      ],
      "halfExtents": [
        0.6,
        0.65,
        0.15
      ],
      "material": "plaster",
      "note": "flank office north lintel"
    },
    {
      "kind": "box",
      "center": [
        0,
        1.75,
        -20.65
      ],
      "halfExtents": [
        0.3,
        1.75,
        0.15
      ],
      "material": "plaster",
      "note": "flank office north wall"
    },
    {
      "kind": "box",
      "center": [
        -0.9,
        2.85,
        -20.65
      ],
      "halfExtents": [
        0.6,
        0.65,
        0.15
      ],
      "material": "plaster",
      "note": "flank office north lintel"
    },
    {
      "kind": "box",
      "center": [
        -2.75,
        1.75,
        -20.65
      ],
      "halfExtents": [
        1.25,
        1.75,
        0.15
      ],
      "material": "plaster",
      "note": "flank office north wall"
    },
    {
      "kind": "box",
      "center": [
        0,
        1.75,
        -25.35
      ],
      "halfExtents": [
        4,
        1.75,
        0.15
      ],
      "material": "plaster",
      "note": "flank office south wall"
    },
    {
      "kind": "box",
      "center": [
        -3.85,
        1.75,
        -23
      ],
      "halfExtents": [
        0.15,
        1.75,
        2.2
      ],
      "material": "plaster",
      "note": "flank office east wall"
    },
    {
      "kind": "box",
      "center": [
        3.85,
        1.75,
        -23
      ],
      "halfExtents": [
        0.15,
        1.75,
        2.2
      ],
      "material": "plaster",
      "note": "flank office west wall"
    },
    {
      "kind": "box",
      "center": [
        0,
        3.6,
        -23
      ],
      "halfExtents": [
        4,
        0.1,
        2.5
      ],
      "material": "plaster",
      "note": "flank office roof"
    },
    {
      "kind": "box",
      "center": [
        15,
        2.25,
        -11
      ],
      "halfExtents": [
        0.075,
        2.25,
        0.075
      ],
      "material": "metal",
      "note": "corridor lamp post"
    },
    {
      "kind": "box",
      "center": [
        15,
        4.3,
        -11
      ],
      "halfExtents": [
        0.35,
        0.12,
        0.35
      ],
      "material": "metal",
      "emissive": "#ffb35c",
      "emissiveIntensity": 3,
      "note": "corridor sodium lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        6,
        2.25,
        -11
      ],
      "halfExtents": [
        0.075,
        2.25,
        0.075
      ],
      "material": "metal",
      "note": "corridor lamp post"
    },
    {
      "kind": "box",
      "center": [
        6,
        4.3,
        -11
      ],
      "halfExtents": [
        0.35,
        0.12,
        0.35
      ],
      "material": "metal",
      "emissive": "#ffb35c",
      "emissiveIntensity": 3,
      "note": "corridor sodium lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -3,
        2.25,
        -11
      ],
      "halfExtents": [
        0.075,
        2.25,
        0.075
      ],
      "material": "metal",
      "note": "corridor lamp post"
    },
    {
      "kind": "box",
      "center": [
        -3,
        4.3,
        -11
      ],
      "halfExtents": [
        0.35,
        0.12,
        0.35
      ],
      "material": "metal",
      "emissive": "#ffb35c",
      "emissiveIntensity": 3,
      "note": "corridor sodium lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -12,
        2.25,
        -11
      ],
      "halfExtents": [
        0.075,
        2.25,
        0.075
      ],
      "material": "metal",
      "note": "corridor lamp post"
    },
    {
      "kind": "box",
      "center": [
        -12,
        4.3,
        -11
      ],
      "halfExtents": [
        0.35,
        0.12,
        0.35
      ],
      "material": "metal",
      "emissive": "#ffb35c",
      "emissiveIntensity": 3,
      "note": "corridor sodium lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -16.5,
        6.5,
        -4
      ],
      "halfExtents": [
        0.1,
        0.04,
        0.04
      ],
      "material": "metal",
      "note": "hall fluorescent fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -9,
        6.78,
        -4
      ],
      "halfExtents": [
        0.04,
        0.22,
        0.04
      ],
      "material": "metal",
      "note": "hall fluorescent fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -3,
        6.78,
        -4
      ],
      "halfExtents": [
        0.04,
        0.22,
        0.04
      ],
      "material": "metal",
      "note": "hall fluorescent fixture mount"
    },
    {
      "kind": "box",
      "center": [
        3,
        6.78,
        -4
      ],
      "halfExtents": [
        0.04,
        0.22,
        0.04
      ],
      "material": "metal",
      "note": "hall fluorescent fixture mount"
    },
    {
      "kind": "box",
      "center": [
        9,
        6.78,
        -4
      ],
      "halfExtents": [
        0.04,
        0.22,
        0.04
      ],
      "material": "metal",
      "note": "hall fluorescent fixture mount"
    },
    {
      "kind": "box",
      "center": [
        16.5,
        6.5,
        -4
      ],
      "halfExtents": [
        0.1,
        0.04,
        0.04
      ],
      "material": "metal",
      "note": "hall fluorescent fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -16.5,
        6.5,
        4
      ],
      "halfExtents": [
        0.1,
        0.04,
        0.04
      ],
      "material": "metal",
      "note": "hall fluorescent fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -9,
        6.78,
        4
      ],
      "halfExtents": [
        0.04,
        0.22,
        0.04
      ],
      "material": "metal",
      "note": "hall fluorescent fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -3,
        6.78,
        4
      ],
      "halfExtents": [
        0.04,
        0.22,
        0.04
      ],
      "material": "metal",
      "note": "hall fluorescent fixture mount"
    },
    {
      "kind": "box",
      "center": [
        3,
        6.78,
        4
      ],
      "halfExtents": [
        0.04,
        0.22,
        0.04
      ],
      "material": "metal",
      "note": "hall fluorescent fixture mount"
    },
    {
      "kind": "box",
      "center": [
        9,
        6.78,
        4
      ],
      "halfExtents": [
        0.04,
        0.22,
        0.04
      ],
      "material": "metal",
      "note": "hall fluorescent fixture mount"
    },
    {
      "kind": "box",
      "center": [
        16.5,
        6.5,
        4
      ],
      "halfExtents": [
        0.1,
        0.04,
        0.04
      ],
      "material": "metal",
      "note": "hall fluorescent fixture mount"
    }
  ],
  "spawns": [
    {
      "position": [
        -37,
        0,
        -24
      ],
      "yaw": 4.137,
      "team": 0
    },
    {
      "position": [
        37,
        0,
        24
      ],
      "yaw": 0.995,
      "team": 1
    },
    {
      "position": [
        -37,
        0,
        -17
      ],
      "yaw": 4.282,
      "team": 0
    },
    {
      "position": [
        37,
        0,
        17
      ],
      "yaw": 1.14,
      "team": 1
    },
    {
      "position": [
        -37,
        0,
        -10
      ],
      "yaw": 4.448,
      "team": 0
    },
    {
      "position": [
        37,
        0,
        10
      ],
      "yaw": 1.307,
      "team": 1
    },
    {
      "position": [
        -37,
        0,
        -3
      ],
      "yaw": 4.631,
      "team": 0
    },
    {
      "position": [
        37,
        0,
        3
      ],
      "yaw": 1.49,
      "team": 1
    },
    {
      "position": [
        -37,
        0,
        4
      ],
      "yaw": 4.82,
      "team": 0
    },
    {
      "position": [
        37,
        0,
        -4
      ],
      "yaw": 1.678,
      "team": 1
    },
    {
      "position": [
        -37,
        0,
        11
      ],
      "yaw": 5.001,
      "team": 0
    },
    {
      "position": [
        37,
        0,
        -11
      ],
      "yaw": 1.86,
      "team": 1
    },
    {
      "position": [
        -37,
        0,
        18
      ],
      "yaw": 5.165,
      "team": 0
    },
    {
      "position": [
        37,
        0,
        -18
      ],
      "yaw": 2.024,
      "team": 1
    },
    {
      "position": [
        -37,
        0,
        25
      ],
      "yaw": 5.307,
      "team": 0
    },
    {
      "position": [
        37,
        0,
        -25
      ],
      "yaw": 2.165,
      "team": 1
    }
  ],
  "props": [
    {
      "model": "/game/models/synty/props/generator-01.glb",
      "position": [
        -3,
        0,
        -1.5
      ],
      "note": "hall dressing"
    },
    {
      "model": "/game/models/synty/props/generator-01.glb",
      "position": [
        3,
        0,
        -1.5
      ],
      "note": "hall dressing"
    },
    {
      "model": "/game/models/hangar/machine_barrelLarge.glb",
      "position": [
        -15.5,
        0,
        -3
      ],
      "note": "desk dressing"
    },
    {
      "model": "/game/models/hangar/machine_barrelLarge.glb",
      "position": [
        15.5,
        0,
        3
      ],
      "note": "desk dressing"
    },
    {
      "model": "/game/models/synty/props/barrel-01.glb",
      "position": [
        -25,
        0,
        -18
      ],
      "note": "yard dressing"
    },
    {
      "model": "/game/models/synty/props/barrel-02.glb",
      "position": [
        -19.5,
        0,
        -13
      ],
      "note": "yard dressing"
    },
    {
      "model": "/game/models/synty/props/tire-stack-01.glb",
      "position": [
        -25.5,
        0,
        12
      ],
      "note": "yard dressing"
    },
    {
      "model": "/game/models/synty/props/wirefence-01.glb",
      "position": [
        -19.5,
        0,
        8
      ],
      "note": "yard dressing"
    },
    {
      "model": "/game/models/synty/props/cardboard-box-01.glb",
      "position": [
        -23.5,
        0,
        -3
      ],
      "note": "yard dressing"
    },
    {
      "model": "/game/models/synty/props/ammo-box-01.glb",
      "position": [
        -36,
        0,
        -10
      ],
      "note": "yard dressing"
    },
    {
      "model": "/game/models/synty/props/weapon-case-01.glb",
      "position": [
        -36,
        0,
        8
      ],
      "note": "yard dressing"
    },
    {
      "model": "/game/models/synty/props/spotlight-01.glb",
      "position": [
        -37,
        0,
        26
      ],
      "note": "yard dressing, beside flood"
    },
    {
      "model": "/game/models/synty/props/propane-01.glb",
      "position": [
        -22,
        0,
        -1
      ],
      "note": "hut dressing"
    },
    {
      "model": "/game/models/street/trash-bag-1.glb",
      "position": [
        -22.5,
        0,
        -3.5
      ],
      "note": "hut dressing"
    },
    {
      "model": "/game/models/hangar/machine_generatorLarge.glb",
      "position": [
        -25,
        0,
        17.5
      ],
      "note": "dock dressing"
    },
    {
      "model": "/game/models/synty/props/wirefence-02.glb",
      "position": [
        -6,
        0,
        22.5
      ],
      "note": "office dressing"
    },
    {
      "model": "/game/models/synty/props/barrel-01.glb",
      "position": [
        25,
        0,
        18
      ],
      "note": "yard dressing"
    },
    {
      "model": "/game/models/synty/props/barrel-02.glb",
      "position": [
        19.5,
        0,
        13
      ],
      "note": "yard dressing"
    },
    {
      "model": "/game/models/synty/props/tire-stack-01.glb",
      "position": [
        25.5,
        0,
        -12
      ],
      "note": "yard dressing"
    },
    {
      "model": "/game/models/synty/props/wirefence-01.glb",
      "position": [
        19.5,
        0,
        -8
      ],
      "note": "yard dressing"
    },
    {
      "model": "/game/models/synty/props/cardboard-box-01.glb",
      "position": [
        23.5,
        0,
        3
      ],
      "note": "yard dressing"
    },
    {
      "model": "/game/models/synty/props/ammo-box-01.glb",
      "position": [
        36,
        0,
        10
      ],
      "note": "yard dressing"
    },
    {
      "model": "/game/models/synty/props/weapon-case-01.glb",
      "position": [
        36,
        0,
        -8
      ],
      "note": "yard dressing"
    },
    {
      "model": "/game/models/synty/props/spotlight-01.glb",
      "position": [
        37,
        0,
        -26
      ],
      "note": "yard dressing, beside flood"
    },
    {
      "model": "/game/models/synty/props/propane-01.glb",
      "position": [
        22,
        0,
        1
      ],
      "note": "hut dressing"
    },
    {
      "model": "/game/models/street/trash-bag-1.glb",
      "position": [
        22.5,
        0,
        3.5
      ],
      "note": "hut dressing"
    },
    {
      "model": "/game/models/hangar/machine_generatorLarge.glb",
      "position": [
        25,
        0,
        -17.5
      ],
      "note": "dock dressing"
    },
    {
      "model": "/game/models/synty/props/wirefence-02.glb",
      "position": [
        6,
        0,
        -22.5
      ],
      "note": "office dressing"
    }
  ],
  "lights": [
    {
      "kind": "point",
      "position": [
        -5.8,
        1.2,
        -8.2
      ],
      "color": "#ff7a2a",
      "intensity": 60,
      "distance": 8,
      "note": "furnace glow lamp"
    },
    {
      "kind": "point",
      "position": [
        0,
        1.2,
        -8.2
      ],
      "color": "#ff7a2a",
      "intensity": 60,
      "distance": 8,
      "note": "furnace glow lamp"
    },
    {
      "kind": "point",
      "position": [
        5.8,
        1.2,
        -8.2
      ],
      "color": "#ff7a2a",
      "intensity": 60,
      "distance": 8,
      "note": "furnace glow lamp"
    },
    {
      "kind": "point",
      "position": [
        -15,
        6.5,
        -4
      ],
      "color": "#cfe4ff",
      "intensity": 90,
      "distance": 14,
      "castShadow": true,
      "note": "hall fluorescent"
    },
    {
      "kind": "point",
      "position": [
        -9,
        6.5,
        -4
      ],
      "color": "#cfe4ff",
      "intensity": 90,
      "distance": 14,
      "note": "hall fluorescent"
    },
    {
      "kind": "point",
      "position": [
        -3,
        6.5,
        -4
      ],
      "color": "#cfe4ff",
      "intensity": 90,
      "distance": 14,
      "note": "hall fluorescent"
    },
    {
      "kind": "point",
      "position": [
        3,
        6.5,
        -4
      ],
      "color": "#cfe4ff",
      "intensity": 90,
      "distance": 14,
      "note": "hall fluorescent"
    },
    {
      "kind": "point",
      "position": [
        9,
        6.5,
        -4
      ],
      "color": "#cfe4ff",
      "intensity": 90,
      "distance": 14,
      "note": "hall fluorescent"
    },
    {
      "kind": "point",
      "position": [
        15,
        6.5,
        -4
      ],
      "color": "#cfe4ff",
      "intensity": 90,
      "distance": 14,
      "note": "hall fluorescent"
    },
    {
      "kind": "point",
      "position": [
        -15,
        6.5,
        4
      ],
      "color": "#cfe4ff",
      "intensity": 90,
      "distance": 14,
      "note": "hall fluorescent"
    },
    {
      "kind": "point",
      "position": [
        -9,
        6.5,
        4
      ],
      "color": "#cfe4ff",
      "intensity": 90,
      "distance": 14,
      "note": "hall fluorescent"
    },
    {
      "kind": "point",
      "position": [
        -3,
        6.5,
        4
      ],
      "color": "#cfe4ff",
      "intensity": 90,
      "distance": 14,
      "note": "hall fluorescent"
    },
    {
      "kind": "point",
      "position": [
        3,
        6.5,
        4
      ],
      "color": "#cfe4ff",
      "intensity": 90,
      "distance": 14,
      "note": "hall fluorescent"
    },
    {
      "kind": "point",
      "position": [
        9,
        6.5,
        4
      ],
      "color": "#cfe4ff",
      "intensity": 90,
      "distance": 14,
      "note": "hall fluorescent"
    },
    {
      "kind": "point",
      "position": [
        15,
        6.5,
        4
      ],
      "color": "#cfe4ff",
      "intensity": 90,
      "distance": 14,
      "note": "hall fluorescent"
    },
    {
      "kind": "point",
      "position": [
        -33,
        4.3,
        -25
      ],
      "color": "#ffb35c",
      "intensity": 120,
      "distance": 16,
      "note": "yard sodium lamp"
    },
    {
      "kind": "point",
      "position": [
        -33,
        4.3,
        -13
      ],
      "color": "#ffb35c",
      "intensity": 120,
      "distance": 16,
      "note": "yard sodium lamp"
    },
    {
      "kind": "point",
      "position": [
        -33,
        4.3,
        0
      ],
      "color": "#ffb35c",
      "intensity": 120,
      "distance": 16,
      "note": "yard sodium lamp"
    },
    {
      "kind": "point",
      "position": [
        -33,
        4.3,
        13
      ],
      "color": "#ffb35c",
      "intensity": 120,
      "distance": 16,
      "note": "yard sodium lamp"
    },
    {
      "kind": "point",
      "position": [
        -33,
        4.3,
        22
      ],
      "color": "#ffb35c",
      "intensity": 120,
      "distance": 16,
      "note": "yard sodium lamp"
    },
    {
      "kind": "point",
      "position": [
        -15,
        4.3,
        11
      ],
      "color": "#ffb35c",
      "intensity": 120,
      "distance": 16,
      "note": "corridor sodium lamp"
    },
    {
      "kind": "point",
      "position": [
        -6,
        4.3,
        11
      ],
      "color": "#ffb35c",
      "intensity": 120,
      "distance": 16,
      "note": "corridor sodium lamp"
    },
    {
      "kind": "point",
      "position": [
        3,
        4.3,
        11
      ],
      "color": "#ffb35c",
      "intensity": 120,
      "distance": 16,
      "note": "corridor sodium lamp"
    },
    {
      "kind": "point",
      "position": [
        12,
        4.3,
        11
      ],
      "color": "#ffb35c",
      "intensity": 120,
      "distance": 16,
      "note": "corridor sodium lamp"
    },
    {
      "kind": "spot",
      "position": [
        -38,
        8,
        27
      ],
      "color": "#fff1d6",
      "intensity": 400,
      "distance": 30,
      "target": [
        -30,
        0,
        5
      ],
      "angle": 0.55,
      "penumbra": 0.4,
      "castShadow": true,
      "note": "yard floodlight"
    },
    {
      "kind": "point",
      "position": [
        33,
        4.3,
        25
      ],
      "color": "#ffb35c",
      "intensity": 120,
      "distance": 16,
      "note": "yard sodium lamp"
    },
    {
      "kind": "point",
      "position": [
        33,
        4.3,
        13
      ],
      "color": "#ffb35c",
      "intensity": 120,
      "distance": 16,
      "note": "yard sodium lamp"
    },
    {
      "kind": "point",
      "position": [
        33,
        4.3,
        0
      ],
      "color": "#ffb35c",
      "intensity": 120,
      "distance": 16,
      "note": "yard sodium lamp"
    },
    {
      "kind": "point",
      "position": [
        33,
        4.3,
        -13
      ],
      "color": "#ffb35c",
      "intensity": 120,
      "distance": 16,
      "note": "yard sodium lamp"
    },
    {
      "kind": "point",
      "position": [
        33,
        4.3,
        -22
      ],
      "color": "#ffb35c",
      "intensity": 120,
      "distance": 16,
      "note": "yard sodium lamp"
    },
    {
      "kind": "point",
      "position": [
        15,
        4.3,
        -11
      ],
      "color": "#ffb35c",
      "intensity": 120,
      "distance": 16,
      "note": "corridor sodium lamp"
    },
    {
      "kind": "point",
      "position": [
        6,
        4.3,
        -11
      ],
      "color": "#ffb35c",
      "intensity": 120,
      "distance": 16,
      "note": "corridor sodium lamp"
    },
    {
      "kind": "point",
      "position": [
        -3,
        4.3,
        -11
      ],
      "color": "#ffb35c",
      "intensity": 120,
      "distance": 16,
      "note": "corridor sodium lamp"
    },
    {
      "kind": "point",
      "position": [
        -12,
        4.3,
        -11
      ],
      "color": "#ffb35c",
      "intensity": 120,
      "distance": 16,
      "note": "corridor sodium lamp"
    },
    {
      "kind": "spot",
      "position": [
        38,
        8,
        -27
      ],
      "color": "#fff1d6",
      "intensity": 400,
      "distance": 30,
      "target": [
        30,
        0,
        -5
      ],
      "angle": 0.55,
      "penumbra": 0.4,
      "castShadow": true,
      "note": "yard floodlight"
    }
  ],
  "sites": [
    {
      "id": "A",
      "center": [
        -5.8,
        0,
        2
      ],
      "halfExtents": [
        4,
        2,
        4
      ]
    },
    {
      "id": "B",
      "center": [
        23.5,
        1.2,
        -17
      ],
      "halfExtents": [
        4,
        2,
        4
      ]
    }
  ]
}
